import { FC, ReactNode } from 'react'
import {
  EventsCollectionCardList,
  EventsCollectionCardListType,
} from './CardList'
import {
  EventsCollectionCollection,
  EventsCollectionCollectionType,
} from './Collection'
import {
  EventsCollectionCardHeader,
  EventsCollectionCardHeaderType,
} from './Header'
import {
  EventsCollectionPreview,
  PreviewEventsCollectionCollectionType,
} from './PreviewCard'

const EventsCollection: FC &
  EventsCollectionCardListType &
  EventsCollectionCollectionType &
  PreviewEventsCollectionCollectionType &
  EventsCollectionCardHeaderType = (): ReactNode => <></>

EventsCollection.Collection = EventsCollectionCollection
EventsCollection.Card = EventsCollectionCardList
EventsCollection.Preview = EventsCollectionPreview
EventsCollection.Header = EventsCollectionCardHeader

export default EventsCollection
